<template>
    <div class="col-12" @click="$emit('template-selected')">
        <div class="row">
            <div class="col-2 icon-container">
                <i class="fa fa-2x fa-user-circle" aria-hidden="true"></i>
            </div>
            <div class="col-7">
                <!-- The actual content -->
                <span class="template-name-label">{{ name }}</span>
                
                <span class="sub-text-label">
                    <slot name="sub-text-label" v-bind:formatted-date="formattedDate"></slot>    
                </span>
            </div>
            <div class="col-3 text-right icon-container">
                <a 
                        v-if="canEdit" 
                        v-bind:href="editUrl" 
                        class="mdb-icon-btn edit"
                        @click.stop
                >
                    <i class="fa fa-pencil fa-lg mr-1" aria-hidden="true"></i>
                </a>
                
                <slot name="additional-controls"></slot>
                
                <i
                        v-if="canDelete"
                        class="fa fa-trash mdb-icon-btn delete fa-lg"
                        aria-hidden="true"
                        @click.stop="promptDeleteRecord"
                ></i>
            </div>
        </div>
    </div>
</template>

<script>
    import templateApi from '../../../../Api/template-manager';
    
    import moment from 'moment';
    
    import resourceMixin from '../../../../Util/Mixins/resources';
    
    import permissionApi from '../../../../Util/security';
    import growlApi from '../../../../Util/growler';
    import { promptV2 as prompt } from '../../../../Util/prompt';
    
    
    export default {
        name: "template-listing-item-base",
        mixins: [resourceMixin],
        computed: {
            formattedDate(){
                const vm = this;
                if(!vm.date){
                    return null;
                }
                
                //3 Juli 2019 14:03
                //Dates are provided as UTC
                return new moment.utc(vm.date)
                    .local()
                    .format('D MMMM YYYY HH:mm');
            },
            editUrl(){
                const vm = this;

                return `/Templates/${vm.id}`
            }
        },
        methods: {
            promptDeleteRecord() {
                const vm = this;
                
                // Attempt to delete template on click of 'Ok' button
                prompt(
                    vm.resource('TemplateListingItemBase_DeleteRecordPrompt_Title'), 
                    vm.resource('TemplateListingItemBase_DeleteRecordPrompt_Body')
                ).then(
                    () => {
                        templateApi.deleteTemplate(vm.id).then(
                            () => vm.$emit('template-deleted'),
                            growlApi.bootstrapDanger
                        )
                    },
                    () => { /*Do nothing */ }
                );
            }
        },
        props: {
            id: {
                type: String,
                required: true
            }, 
            name: {
                type: String,
                required: true
            },
            date: {
                type: [String, Date],
                required: false
            },
            canEdit: {
                type: Boolean,
                default: false,
                required: false
            },
            canDelete: {
                type: Boolean,
                default: false,
                required: false
            }
        }
    };
</script>

<style scoped src="../../Style/template-listing-item-base.scss" lang="scss">
</style>
